import axios from 'axios'
import store from '@/store/index.js';

class HttpRequest {
    constructor(url = process.env.VUE_APP_API_URL) {
        // this.axios = axios
        this.axiosInstance = axios.create({
            baseURL: url,
            timeout: 120000,
            withCredentials: true,
        })

        this.axiosInstance.interceptors.request.use(async (config) => {
            // Do something before request is sent
            const token = await store.dispatch('keycloak/getToken') || sessionStorage.getItem('token');
            if (token) return { ...config, headers: { 'Authorization': 'Bearer ' + token } };
            return config;
        }, function (error) {
            // Do something with request error
            return Promise.reject(error)
        })

        // Add a response interceptor
        this.axiosInstance.interceptors.response.use(function (response) {
            // Do something with response data
            return response
        }, function (error) {
            // Do something with response error
            return Promise.reject(error)
        })
    }

    setHeader(header) {
        this.axiosInstance.defaults.headers.common[header.key] = header.value
    }

    get(url, data, config) {
        return this.axiosInstance.get(url, { params: data, ...config })
    }

    create(url, data, config) {
        return this.axiosInstance.post(url, data, config)
    }

    post(url, data, config) {
        return this.axiosInstance.post(url, data, config)
    }

    update(url, data, config) {
        return this.axiosInstance.put(url, data, config)
    }

    delete(url, param, data, config) {
        return this.axiosInstance.delete(url, { params: param, data: data, ...config })
    }

    request(type, url, data) {
        let promise = null
        switch (type) {
            case 'GET': promise = axios.get(url, { params: data }); break
            case 'POST': promise = axios.post(url, data); break
            case 'PUT': promise = axios.put(url, data); break
            case 'DELETE': promise = axios.delete(url, data); break
            default: promise = axios.get(url, { params: data }); break
        }
        return promise
    }
}

export default HttpRequest